// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1WYjL","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1uDED","obliqueLine":"membershipbadge_obliqueLine__2sq5P"};